<template>
  <div class="winners-section">
    <p class="menu1_head1 mt-10">{{ $t("winners_title") }}</p>

    <div class="mobile-select">
      <select v-model="selectedTab">
        <option v-for="item in statuss" :key="item.id" :value="item.id">
          {{ item.name }}
        </option>
      </select>
    </div>

    <div class="table-scroll-wrapper">
      <div class="winners-table">
        <div class="table-header">
          <span>{{ $t("date") }}</span>
          <span>{{ $t("fiscal") }}</span>
          <span>{{ $t("winner") }}</span>
        </div>
        <div v-for="item in paginatedData" :key="item.id" class="table-row">
          <span>{{ formatDate(item.winDate) }}</span>
          <span>{{ item.fiscalId }}</span>
          <span>{{ `${item.name} ${item.surname}` }}</span>
        </div>
        <div class="pagination">
          <button @click="prevPage" :disabled="currentPage === 1">‹</button>
          <button @click="nextPage" :disabled="currentPage === totalPages">
            ›
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "WinnersSection",
  data() {
    return {
      selectedTab: null, // now PrizeId
      currentPage: 1,
      perPage: 5,
      statuss: [],
      winners: [],
    };
  },
  computed: {
    paginatedData() {
      const start = (this.currentPage - 1) * this.perPage;
      return this.winners.slice(start, start + this.perPage);
    },
    totalPages() {
      return Math.ceil(this.winners.length / this.perPage);
    },
    lang() {
      return this.$i18n.locale || "az";
    },
  },
  methods: {
    getPrizes() {
      axios
        .get(
          `${this.$store.getters.getUrl}Present/AllLottery?lang=${this.lang}`,
          this.config
        )
        .then((res) => {
          if (res.data.success) {
            this.statuss = res.data.value.map((item) => ({
              id: item.id,
              name: item.name,
            }));
            this.selectedTab = this.statuss[0]?.id || null;
            if (this.selectedTab) {
              this.getWinnersByPrizeId(this.selectedTab);
            }
          }
        })
        .catch(() => {
          this.$toast.error("Priz siyahısı yüklənmədi!");
        });
    },
    getWinnersByPrizeId(prizeId) {
      axios
        .get(
          `${this.$store.getters.getUrl}Winner/winners/filter?PrizeId=${prizeId}`
        )
        .then((res) => {
          if (res.data.success) {
            this.winners = res.data.value;
            this.currentPage = 1;
          }
        })
        .catch(() => {
          this.$toast.error("Qaliblər yüklənmədi!");
        });
    },
    maskNumber(number) {
      return number.replace(/(\+?\d{0,3})\d+(?=\d{2})/, "$1 *** *** ");
    },
    formatDate(dateStr) {
      const date = new Date(dateStr);
      return date.toLocaleDateString("az");
    },
    nextPage() {
      if (this.currentPage < this.totalPages) this.currentPage++;
    },
    prevPage() {
      if (this.currentPage > 1) this.currentPage--;
    },
  },
  created() {
    this.getPrizes();
  },
  watch: {
    selectedTab(newPrizeId) {
      if (newPrizeId) this.getWinnersByPrizeId(newPrizeId);
    },
    lang() {
      this.getPrizes();
    },
  },
};
</script>

<style scoped>
.winners-section {
  text-align: center;
  color: white;
  max-width: 120rem;
  margin: 0 auto;
}

.mobile-select {
  margin: 2rem auto;
  display: flex;
  justify-content: center;
  width: 100%;
  padding: 0 2rem;
}

.mobile-select select {
  width: 55rem;
  max-width: 100%;
  padding: 1.2rem 2.8rem 1.2rem 1.4rem;
  font-size: 2.2rem;
  font-weight: 600;
  border: none;
  border-radius: 14px;
  color: white;
  background-image: url("data:image/svg+xml,%3Csvg width='24' height='24' fill='none' stroke='%23ed3130' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' viewBox='0 0 24 24'%3E%3Cpath d='M6 9l6 6 6-6'/%3E%3C/svg%3E");
  background-repeat: no-repeat;
  background-position: right 1rem center;
  background-size: 1.4rem;

  cursor: pointer;

  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.12);

  transition: box-shadow 0.3s ease;
  padding-right: 3rem;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: clip;
}

.mobile-select select,
::picker(select) {
  appearance: base-select;
}
.mobile-select select::picker-icon {
  color: #283da4;
}

.mobile-select select:hover,
.mobile-select select:focus {
  outline: none;
}

@media (max-width: 690px) {
  .mobile-select {
    justify-content: center;
    padding: 0;
  }

  .mobile-select select {
    width: 90%;
    font-size: 2.1rem;
    padding: 1.2rem 1.4rem;
    background-position: right 1rem center;
    appearance: none;
    -webkit-appearance: none;
    -moz-appearance: none;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    background-image: url("data:image/svg+xml;charset=UTF-8,%3Csvg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M7 10L12 15L17 10' stroke='white' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E");
    background-repeat: no-repeat;
    background-position: right 1rem center;
    background-size: 1.5rem;
    cursor: pointer;
    padding-right: 3rem;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: clip;
  }
}

option {
  color: black;
}

.table-scroll-wrapper {
  overflow-x: auto;
  padding: 0 1rem;
}

.table-scroll-wrapper::-webkit-scrollbar {
  height: 8px;
}
.table-scroll-wrapper::-webkit-scrollbar-thumb {
  background-color: rgba(255, 255, 255, 0.4);
  border-radius: 4px;
}

.winners-table {
  min-width: 62rem;
  width: 90%;
  background: linear-gradient(180deg, #ffffffcc 70%, #ffffff00 100%);
  border: none;
  border-radius: 20px;
  margin: auto;
  overflow: hidden;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.05);
}

.table-header,
.table-row {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  padding: 0.8rem 1rem;
}

.table-header {
  background: rgba(255, 255, 255, 0.7);
  font-size: 2.6rem;
  color: #283da4;
  font-weight: bold;
  backdrop-filter: blur(8px);
  border-bottom: 1px solid #ccc;
}

.table-row {
  background: rgba(255, 255, 255, 0.25);
  color: #3a4daa;
  font-size: 2rem;
  border-top: 1px solid rgba(0, 0, 0, 0.05);
  transition: background 0.2s ease;
}

.table-row:hover {
  background: rgba(255, 255, 255, 0.4);
}

.pagination {
  display: flex;
  justify-content: center;
  gap: 1rem;
  margin-top: 1.5rem;
}

.pagination button {
  color: #ed3130;
  font-size: 4rem;
}

.pagination button:hover:not(:disabled) {
  color: #ffffff;
}

.pagination button:disabled {
  color: #bbb;
}
</style>
